const bucketMapping = {
  customer: "customer",
  product: "product",
};

export default bucketMapping;
